<template>
  <section class="userInfo">
    <div class="avater_box">
      <img class="avatar" :src="headImg" alt="">
      <div class="update" @click="updateAcatar = true">更换</div>
    </div>
    <p class="name">
      <span>{{username | addStar}}</span>
      <i class="iconfont icon-bianji1" @click="usernameShow=true"></i>
    </p>
    <div class="name_tip">好的昵称可以让别人更容易记住你</div>
    <!-- <el-button @click="showIdentity = true" round size="mini" class="occupation"> -->
    <!-- <el-button round size="mini" class="occupation">
      {{identityName}} -->
      <!-- <i class="iconfont icon-bianji1"></i> -->
    <!-- </el-button> -->
    <!-- 选择身份信息 -->
    <el-dialog title="请选择当前身份" :visible.sync="showIdentity" width="413px" :close-on-click-modal="false" :show-close="false">
      <section class="identity">
        <p class="hint">进入后，也可在[账号中心]编辑为其他身份</p>
        <div :class="['stylist',{active:isActive}]">
          <div class="stylistType">
            <span>我是</span>
            <div @click="selectIndentity(2)" :class="{active:identityList.includes(2)}">
              工艺设计师
              <i v-show="identityList.includes(2)" class="iconfont icon-icon-xuanzhong"></i>
            </div>
            <div @click="selectIndentity(4)" :class="{active:identityList.includes(4)}">
              视觉设计师
              <i v-show="identityList.includes(4)" class="iconfont icon-icon-xuanzhong"></i>
            </div>
          </div>
          <img src="../../../assets/img/stylist.png" alt="">
        </div>
        <div @click="selectIndentity(0)" :class="['stylist',{active:identityList.includes(0)}]">
          <div :class="['buyer',{active:identityList.includes(0)}]">我是买家</div>
          <img src="../../../assets/img/buyer.png" alt="">
        </div>
        <div class="btnBox">
          <el-button @click="setIndentity" :loading="btnLoading" size="medium" type="primary">确定</el-button>
        </div>
      </section>
    </el-dialog>
    <!-- 修改昵称 -->
    <el-dialog title="更改昵称" :visible.sync="usernameShow" @open="open" width="368px" :close-on-click-modal="false" destroy-on-close>
      <el-form :model="form" :rules="rules" ref="form" class="updateUsername">
        <el-form-item prop="username">
          <el-input v-model="form.username" maxlength="20" placeholder="请输入昵称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="usernameShow = false">取消</el-button>
        <el-button size="medium" type="primary" @click="setUsername" :loading="btnLoading">保存</el-button>
      </div>
    </el-dialog>
    <!-- 修改头像裁切弹框 -->
    <PhotoClip :show.sync="updateAcatar" title="编辑头像" @save="updateAcatarSub" :shape="2" width="490px" />
  </section>
</template>

<script>
// 请求模块
import { updateUserInfo } from "../../../api/accountManage";
import { mapActions } from "vuex";
// 表单验证
import { nickNameVerify } from "../../../tool";
// 头像裁剪
import PhotoClip from "../../../components/PhotoClip/index.vue";
export default {
  components: { PhotoClip },
  props: {
    headImg: {
      type: String,
      default: require('../../../assets/img/avatar.png')
    },
    username: {
      type: String,
      default: null
    },
    identity: {
      type: Array,
      default: null
    },
  },
  data() {
    return {
      showIdentity: false, // 修改身份弹框
      usernameShow: false, // 修改用户名显示
      updateAcatar: false, // 修改头像弹框显示
      identityList: [],  // 身份类型 0买家1:设计师 2:买家和设计师
      identityName: null,
      name: {
        1: "设计师",
        2: "设计师，买家",
        0: "买家"
      },
      btnLoading: false,
      form: {
        username: null
      },
      rules: {
        username: [{ validator: nickNameVerify, trigger: "blur" }]
      }
    }
  },
  computed: {
    isActive() {
      for (let i = 0; i < this.identityList.length; i++) {
        if (this.identityList[i] >= 1 && this.identityList[i] < 5) {
          return true
        }
      }
      return false
    }
  },
  watch: {
    identity(val) {
      let nameArr = []
      for (let i = 0; i < val.length; i++) {
        nameArr.push(this.name[val[i]])
      }
      this.$set(this.$data, "identityList", val);
      this.identityName = nameArr.join("，")
      if (!val || val.length <= 0) {
        // this.showIdentity = true
      }
    },
    username(val) {
      this.form.username = val
    }
  },
  methods: {
    ...mapActions(["getUserInfo", "logout"]),
    // 打开修改身份弹框
    open() {
      this.form.username = this.username
    },
    // 选择身份
    selectIndentity(type) {
      if (type === 0) {
        this.identityList = []
        this.identityList.push(type)
      } else {
        if (this.identityList.includes(0)) {
          this.identityList = []
        }
        let isHas = this.identityList.find(item => item === type)
        if (isHas) {
          for (let i = 0; i < this.identityList.length; i++) {
            if (this.identityList[i] === isHas) {
              this.identityList.splice(i, 1)
              break
            }
          }
        } else {
          this.identityList.push(type)
        }
      }
    },
    // 设置身份
    async setIndentity() {
      if (this.identityList.length > 0) {
        this.btnLoading = true
        let res = await updateUserInfo({
          identity: this.identityList.reduce((a, b) => Number(a) + Number(b)),
        }).catch(() => {
          this.btnLoading = false
        })
        if (res.code === 1) {
          this.getUserInfo()
          this.$message({
            type: "success",
            message: "身份设置成功"
          })
          this.showIdentity = false
        }
        this.btnLoading = false
      } else {
        this.$message({
          type: "warning",
          message: "请先选择身份"
        })
      }
    },
    // 修改昵称
    setUsername() {
      // 未改动时不请求接口
      if(this.form.username === this.username) {
        this.usernameShow = false;
        return;
      }
      this.$refs["form"].validate(async valid => {
        if (valid) {
          this.btnLoading = true
          let res = await updateUserInfo({
            nickName: this.form.username
          }).catch(() => {
            this.btnLoading = false
          })
          if (res.code === 1) {
            this.getUserInfo()
            this.$message.success("修改昵称成功")
            this.usernameShow = false
          }
          this.btnLoading = false
        }
      })
    },
    async updateAcatarSub(imgObj) {
      let res = await updateUserInfo({ headImg: imgObj.fileSrc })
      if (res.code === 1) {
        this.getUserInfo()
        this.updateAcatar = false
      }
    }
  }
}
</script>

<style lang="scss">
.userInfo {
   width: 100%;
  // height: 213px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 0 32px;
  background-color: #fff;
  .avater_box {
    position: relative;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    overflow: hidden;
    .avatar {
      width: 76px;
      height: 76px;
      cursor: pointer;
      border-radius: 50%;
    }
    .update {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 76px;
      height: 25px;
      background-color: rgba(#000000, 0.42);
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      color: #FFFFFF;
      line-height: 25px;
      text-align: center;
      cursor: pointer;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Chrome/Safari/Opera */
      -khtml-user-select: none; /* Konqueror */
      -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently not supported by any browser */
    }
  }
  .name {
    color: $textColor;
    font-size: 14px;
    padding: 10px 0 3px;
    color: #202D40;
    line-height: 20px;
    i {
      margin-left: 4px;
      font-size: 14px;
      color: $gray;
      cursor: pointer;
    }
  }
  .name_tip {
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  }
  .occupation {
    color: $primaryColor;
    background: rgba($primaryColor, 0.05);
    border: 0;
    i {
      margin-left: 4px;
      font-size: 10px;
    }
  }
  .identity {
    .hint {
      color: $gray;
      font-size: 12px;
      margin-bottom: 35px;
    }
    .stylist {
      padding: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 2px;
      border: 1px solid $grayBorder;
      margin-bottom: 24px;
      &.active {
        border-color: $primaryColor;
      }
      & > .stylistType {
        display: flex;
        align-items: center;
        & > div {
          position: relative;
          padding: 6px 17px 6px 12px;
          cursor: pointer;
          margin-left: 8px;
          background: $grayBgColor;
          border: 1px solid transparent;
          line-height: 100%;
          border-radius: 2px;
          overflow: hidden;
          &.active {
            border-color: $primaryColor;
          }
          i {
            position: absolute;
            right: -2px;
            bottom: -2px;
            font-size: 12px;
            color: $primaryColor;
          }
        }
      }
      .buyer {
        position: relative;
        padding-left: 29px;
        cursor: pointer;
        &.active {
          &::before {
            content: '✔';
            font-size: 17px;
            color: $primaryColor;
            border-color: $primaryColor;
          }
        }
        &::before {
          position: absolute;
          text-align: center;
          line-height: 20px;
          left: 0;
          top: calc(50% - 9px);
          content: '';
          display: inline-block;
          width: 17px;
          height: 17px;
          border-radius: 50%;
          border: 1px solid $grayBorder;
        }
      }
      img {
        width: 78px;
      }
    }
    .btnBox {
      padding-top: 8px;
      padding-bottom: 32px;
      text-align: center;
      .el-button {
        width: 90px;
      }
    }
  }
  .updateUsername {
    margin-top: 18px;
    .el-input {
      input {
        height: 48px;
      }
    }
  }
}
</style>